
function Brainerd(){
    return <p>Brainerd defualt</p>
}

export default Brainerd